/* eslint-disable no-loop-func */
/* eslint-disable no-continue */
/* eslint-disable no-plusplus */
// eslint-disable-next-line no-use-before-define
import React, { ReactElement, ReactNode, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Menu, MenuProps } from 'antd';

import { rbacProcess } from 'shared/components/privateRouter';
import { RoleName, RolesEnum } from 'core/models/roleModel';
import userAdd from 'pages/usersManagement/pages/userAdd';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store/combineReducers';
import { config } from 'core/config';
import { isSuperAdmin } from 'utils/auth';
import { MenuItem } from '../menu/Menu';

const { SubMenu, Item } = Menu;

const {
  studies,
  settings,
  rpmRT,
  groupManagement,
  analysisSetting,
  otherSetting,
  monitoringProtocols,
  studiesManagement,
  dashboardRpmAlert,
  ssoSetting,
  downloads,
  reportArchive,
} = config.paths;

const isAccept = (item: MenuItem, roleName: RoleName): boolean => {
  if (item.path === '' && item.subMenu && item.subMenu?.length > 0) {
    return true;
  }
  return !!roleName && rbacProcess(`${item.path}`, roleName);
};

export interface MenuItemProps {
  menuList: MenuItem[];
  roleNames?: any;
}

export default function MenuItems({
  menuList,
  roleNames,
}: MenuItemProps): MenuProps['items'] {
  const { user } = useSelector((state: ApplicationState) => state.session);
  if (!roleNames) {
    return [];
  }
  const menuListNew: MenuItem[] = [];
  const arr: any[] = [];
  for (let i = 0; i < menuList.length; i++) {
    const menuItem = menuList[i];
    if (!user?.tenant?.downloadEnabled && menuItem?.path === downloads) {
      continue;
    }
    if (!user?.tenant?.archiveEnabled && menuItem?.path === reportArchive) {
      continue;
    }
    const hasMenu = roleNames.find((roleName: RoleName) => {
      return isAccept(menuItem, roleName);
    });
    if (hasMenu) {
      menuListNew.push(menuList[i]);
    }
  }
  for (let i = 0; i < menuListNew.length; i++) {
    const subMenuList: MenuItem[] = [];
    const item = menuListNew[i];
    if (item.subMenu != null && item.subMenu.length > 0) {
      for (let n = 0; n < item.subMenu.length; n++) {
        const subMenu_ = item.subMenu[n];
        if (
          user?.tenant?.rpmStatus === false &&
          [rpmRT, dashboardRpmAlert].includes(subMenu_.path)
        ) {
          continue;
        }
        if (
          !isSuperAdmin(user) &&
          user?.tenant?.rpmStatus === false &&
          subMenu_.path === groupManagement
        ) {
          continue;
        }
        if (!user?.tenant?.ssoEnabled && subMenu_?.path === ssoSetting) {
          continue;
        }
        const hasMenu = roleNames.find((roleName: RoleName) => {
          return isAccept(subMenu_, roleName);
        });
        if (hasMenu) {
          subMenuList.push(subMenu_);
        }
      }
      if (item.subMenu != null && subMenuList.length > 0) {
        item.subMenu = subMenuList;
        arr.push(item);
      }
    } else {
      arr.push(item);
    }
  }

  return Array.from(new Set(arr)).map((item) => {
    if (item.subMenu != null && item.subMenu.length > 0) {
      const menuItem = {
        label: item.title,
        key: item.id,
        icon: item.icon,
        disabled: false,
        children: [],
      };
      const subMenuItemList = item.subMenu.map((item2: MenuItem) => {
        const subMenuItem = {
          label: (
            <Link to={item2.path} title={item2.title}>
              {item2.title}
            </Link>
          ),
          key: item2.id,
          disabled: false,
        };
        return subMenuItem;
      });
      menuItem.children = subMenuItemList;
      return menuItem;
    }
    const menuItem = {
      label: (
        <Link to={item.path} title={item.title}>
          {item.title}
        </Link>
      ),
      key: item.id,
      icon: item.icon,
      disabled: false,
    };
    return menuItem;
  });
}
